import { useMutation } from '@tanstack/react-query';
import { postSignIn } from '../services/signIn';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router';
import { ACTIONS, useAuth } from '@/contexts/auth';
import { storeUser } from '@/services/storage';
import { SignInSchemaType } from '../schemas/signin';

type PropsType = {
  onError?: (error: AxiosError<unknown>) => void | undefined;
};

type UseSignIn = {
  isLoading: boolean;
  onSuccess: (data: SignInSchemaType) => void;
};

export function useSignIn(props: PropsType): UseSignIn {
  const { dispatch } = useAuth();
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: postSignIn,
    onError: props.onError,
    onSuccess: async (data) => {
      await storeUser(data);
      dispatch({
        type: ACTIONS.LOGIN,
        user: data,
      });
      navigate('/');
    },
  });

  const onSuccess = (data: SignInSchemaType) => {
    mutation.mutate(data);
  };

  const isLoading = mutation.isPending;

  return {
    onSuccess,
    isLoading,
  };
}
